/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_HelpInputs */



/**
* | output |
* | --- |
* | "Choose a start and end point to export just part of your video" |
*
* @param {Video_Export_Segment_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_help = /** @type {((inputs?: Video_Export_Segment_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un point de départ et un point d'arrivée pour exporter seulement une partie de votre vidéo.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Start- und Endpunkt, um nur einen Teil Ihres Videos zu exportieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli un punto di inizio e un punto di fine per esportare solo una parte del tuo video.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите начальную и конечную точки, чтобы экспортировать только часть видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige un punto de inicio y un punto final para exportar solo una parte de tu vídeo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择视频的起始点和结束点，即可导出视频的一部分。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画の一部だけをエクスポートするには、開始点と終了点を選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने वीडियो के केवल एक हिस्से को निर्यात करने के लिए प्रारंभ और समाप्ति बिंदु चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha um ponto inicial e um ponto final para exportar apenas parte do seu vídeo.")
	return /** @type {LocalizedString} */ ("Choose a start and end point to export just part of your video")
});